"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCorrectMessage = exports.StyledOtherTextInputWrapper = exports.StyledOtherOptionContainer = exports.StyledOption = exports.StyledOptionsContainer = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var themes_1 = require("../../themes");
var mixins_1 = require("../../../themes/mixins");
var Typo2_1 = require("../Typo2");
var baseStyling_1 = require("../../themes/utils/baseStyling");
exports.StyledOptionsContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: ", ";\n  align-items: center;\n\n  ", "\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  gap: ", ";\n  align-items: center;\n\n  ", "\n"])), function (_a) {
    var S = _a.S;
    return (S ? "0.7rem 1.5rem" : "1rem 2rem");
}, function (_a) {
    var listType = _a.listType;
    return listType === "vertical"
        ? (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          flex-direction: column;\n\n          gap: ", "; //0.6 because on mobile checkbox & radio has 0.4 rem extra click area top and bottom. so 1.4rem - 0.8rem\n          align-items: flex-start;\n          ", " {\n            gap: ", ";\n          }\n        "], ["\n          flex-direction: column;\n\n          gap: ", "; //0.6 because on mobile checkbox & radio has 0.4 rem extra click area top and bottom. so 1.4rem - 0.8rem\n          align-items: flex-start;\n          ", " {\n            gap: ", ";\n          }\n        "])), function (_a) {
            var S = _a.S;
            return S
                ? "1rem"
                : "0.6rem";
        }, (0, mixins_1.mediaQuery)("md"), function (_a) {
            var S = _a.S;
            return (S ? "1rem" : "1.4rem");
        }) : "";
});
exports.StyledOption = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border: none;\n  background-color: unset;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  /* gap: ", "; */\n  gap: 0.8rem;\n  padding: 0.4rem 0; //this is so that there is more click area on mobile\n  ", " {\n    gap: 0.6rem;\n    padding: 0;\n  }\n  position: relative;\n  cursor: ", ";\n\n  &:hover .radioOrCheckboxButton_inside_input {\n    ", "\n    \n    // here we manually trigger what apply10PeecentBlackOnHover does\n    ", "\n  }\n"], ["\n  border: none;\n  background-color: unset;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  /* gap: ", "; */\n  gap: 0.8rem;\n  padding: 0.4rem 0; //this is so that there is more click area on mobile\n  ", " {\n    gap: 0.6rem;\n    padding: 0;\n  }\n  position: relative;\n  cursor: ", ";\n\n  &:hover .radioOrCheckboxButton_inside_input {\n    ", "\n    \n    // here we manually trigger what apply10PeecentBlackOnHover does\n    ", "\n  }\n"])), function (_a) {
    var S = _a.S;
    return (S ? "0.7rem" : "1rem");
}, (0, mixins_1.mediaQuery)("md"), function (_a) {
    var rightWrongResult = _a.rightWrongResult, disabled = _a.disabled;
    return disabled ? "not-allowed" : rightWrongResult ? "initial" : "pointer";
}, function (_a) {
    var isSelected = _a.isSelected, rightWrongResult = _a.rightWrongResult, disabled = _a.disabled, theme = _a.theme, invert = _a.invert;
    return !isSelected &&
        !rightWrongResult &&
        !disabled && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        border: 1px solid ", ";\n      "], ["\n        border: 1px solid ", ";\n      "])), themes_1.colors.grey50);
}, function (_a) {
    var isSelected = _a.isSelected, disabled = _a.disabled;
    return isSelected &&
        !disabled && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        &::before {\n          ", "\n        }\n      "], ["\n        &::before {\n          ", "\n        }\n      "])), baseStyling_1.blackOverlayEffect);
});
exports.StyledOtherOptionContainer = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  gap: 1rem;\n  flex-direction: ", ";\n"], ["\n  display: flex;\n  gap: 1rem;\n  flex-direction: ", ";\n"])), function (_a) {
    var listType = _a.listType;
    return listType == "vertical" ? "column" : "row";
});
exports.StyledOtherTextInputWrapper = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  margin-right: 0.5rem;\n  ", "\n\n  ", ";\n\n  ", " {\n    width: 28rem;\n  }\n"], ["\n  margin-right: 0.5rem;\n  ", "\n\n  ", ";\n\n  ", " {\n    width: 28rem;\n  }\n"])), function (_a) {
    var rightWrongResult = _a.rightWrongResult;
    return rightWrongResult && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      pointer-events: none;\n    "], ["\n      pointer-events: none;\n    "])));
}, function (_a) {
    var listType = _a.listType;
    return listType === "vertical"
        ? (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n          margin-left: 2.5rem;\n        "], ["\n          margin-left: 2.5rem;\n        "]))) : (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n          width: 28rem;\n        "], ["\n          width: 28rem;\n        "])));
}, (0, mixins_1.mediaQuery)("sm"));
exports.StyledCorrectMessage = (0, styled_components_1.default)(Typo2_1.UI_CAPTION)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  color: ", ";\n  padding-top: 1rem;\n"], ["\n  color: ", ";\n  padding-top: 1rem;\n"])), function (_a) {
    var invert = _a.invert;
    return (invert ? themes_1.colors.white : themes_1.colors.grey90);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
